import { render, staticRenderFns } from "./game_n.vue?vue&type=template&id=39400adb&scoped=true"
import script from "./game_n.vue?vue&type=script&lang=js"
export * from "./game_n.vue?vue&type=script&lang=js"
import style0 from "./game_n.vue?vue&type=style&index=0&id=39400adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39400adb",
  null
  
)

export default component.exports